/**
 * Arabic Translations
 */

import type { DashboardTranslations } from './types'

export const arTranslations: DashboardTranslations = {
  overview: 'نظرة عامة',

  balance: {
    title: 'الرصيد المتاح',
    creditLimit: 'حد الائتمان',
    available: 'متاح',
    used: 'مستخدم',
    wallet: 'المحفظة',
  },

  orders: {
    title: 'إجمالي الطلبات',
    pending: 'قيد الانتظار',
    processing: 'قيد المعالجة',
    delivered: 'تم التسليم',
    total: 'الإجمالي',
  },

  deliveries: {
    title: 'المنتجات المسلمة',
    tons: 'طن',
    count: 'تسليمات',
    accepted: 'مقبولة',
    pending: 'قيد الانتظار',
  },

  summary: {
    totalQuantity: 'إجمالي الكمية',
    cities: 'المدن',
    customers: 'العملاء',
    orders: 'الطلبات',
  },

  pending: {
    title: 'في انتظار الاستلام',
    processing: 'قيد المعالجة',
    awaiting: 'في انتظار الاستلام',
  },

  pendingDeliveries: {
    title: 'تسليمات معلقة',
    accepted: 'مقبولة',
    awaiting: 'في انتظار القبول',
  },

  dateRange: {
    today: 'اليوم',
    thisWeek: 'هذا الأسبوع',
    thisMonth: 'هذا الشهر',
    thisQuarter: 'هذا الربع',
    thisYear: 'هذه السنة',
    last30Days: 'آخر 30 يوم',
    custom: 'نطاق مخصص',
    from: 'من',
    to: 'إلى',
  },

  error: {
    loadFailed: 'فشل في تحميل بيانات لوحة التحكم. يرجى المحاولة مرة أخرى.',
    refreshFailed: 'فشل في تحديث بيانات لوحة التحكم.',
  },

  chart: {
    orderActivity: 'نشاط الطلبات',
    trend: 'اتجاه الطلبات والتسليمات',
    totalQuantityOverTime: 'إجمالي الكمية عبر الوقت',
    quantityTrend: 'اتجاه الأطنان المسلّمة خلال الفترة المحددة',
    orders: 'الطلبات',
    tons: 'الأطنان المسلمة',
  },

  rankings: {
    title: 'تصنيفات الأداء',
    subtitle: 'أفضل المنتجات والعملاء ومواقع التسليم أداءً',
    topProducts: 'أعلى المنتجات',
    topProductsByPackaging: 'أعلى المنتجات حسب التغليف',
    topCustomers: 'توزيع العملاء',
    topCities: 'أعلى مدن التسليم',
    deliveredTons: 'الأطنان المسلّمة',
    bulk: 'سائب',
    bags: 'أكياس',
    chartTypes: 'الرسم',
    noData: 'لا توجد بيانات للفترة المحددة',
    marketShare: 'حصة الحجم حسب كبار العملاء',
    byTons: 'توزيع الحجم حسب نوع التغليف',
    deliveryLocations: 'التوزيع الجغرافي للتسليمات',
    factoryPerformance: 'أداء المصانع',
    factoryPerformanceDesc: 'حجم التسليمات لكل مصنع',
    clickForDetails: 'اضغط على المصنع لعرض التفاصيل',
    clickItemForDetails: 'اضغط على العنصر لعرض التفاصيل',
  },

  factoryDrawer: {
    title: 'تفاصيل المصنع',
    overview: 'نظرة عامة',
    topProducts: 'أفضل المنتجات',
    topCustomers: 'أفضل العملاء',
    topCities: 'أفضل المدن',
    totalTons: 'إجمالي الأطنان',
    totalOrders: 'الطلبات',
    totalProducts: 'المنتجات',
    totalDeliveries: 'التسليمات',
    bulk: 'سائب',
    bags: 'أكياس',
    noData: 'لا توجد بيانات',
    packagingBreakdown: 'توزيع التغليف',
  },

  entityDrawer: {
    customerDetails: 'تفاصيل العميل',
    productDetails: 'تفاصيل المنتج',
    cityDetails: 'تفاصيل المدينة',
    topPlants: 'أفضل المصانع',
    topProducts: 'أفضل المنتجات',
    topCustomers: 'أفضل العملاء',
    topCities: 'أفضل المدن',
    overview: 'نظرة عامة',
    totalTons: 'إجمالي الأطنان',
    totalOrders: 'الطلبات',
    totalProducts: 'المنتجات',
    totalDeliveries: 'التسليمات',
    bulk: 'سائب',
    bags: 'أكياس',
    noData: 'لا توجد بيانات',
    packagingBreakdown: 'توزيع التغليف',
  },

  liveFeed: {
    title: 'مباشر في المصنع',
    subtitle: '{{count}} مركبات حالياً في المصنع',
    empty: 'لا توجد مركبات في المصنع الآن',
    lastUpdated: 'آخر تحديث: {{time}}',
    fields: {
      driver: 'السائق',
      factory: 'المصنع',
      customer: 'العميل',
      loadingLocation: 'موقع التحميل',
      product: 'المنتج',
    },
    status: {
      arrived: 'وصل',
      loading: 'جاري التحميل',
      weighing: 'جاري الوزن',
      completed: 'مكتمل',
    },
  },

  quickActions: {
    title: 'إجراءات سريعة',
    newSalesOrder: 'طلب مبيعات جديد',
    myOrders: 'طلباتي',
  },

  ordersValue: {
    title: 'قيمة الطلبات (شامل ضريبة القيمة المضافة)',
    subtitle: 'إجمالي الطلبات النشطة مع ضريبة 15%',
    beforeTax: 'قبل الضريبة',
    tax: 'ضريبة القيمة المضافة 15%',
    activeOrders: 'طلبات نشطة',
  },

  customerBalance: {
    title: 'رصيد العميل',
    subtitle: 'الرصيد المتاح في حسابك',
  },

  balanceDiff: {
    title: 'الرصيد مقابل الطلبات',
    surplus: 'فائض',
    deficit: 'عجز',
  },

  units: {
    bulk: 'سائب',
    bags: 'أكياس',
  },

  currency: {
    sar: 'ر.س',
    usd: 'دولار',
  },
}
